import values from "./values.json"
export const colours = values.colours
